import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_back_date_order: { message: "idle" },
};

export const tenant_back_date_order_Slice = createSlice({
 name: "tenant_back_date_order",
 initialState,
 reducers: {
  success_tenant_back_date_order: (state, action) => {
   state.tenant_back_date_order = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_back_date_order: (state, action) => {
   state.tenant_back_date_order = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_back_date_order: (state) => {
   state.tenant_back_date_order = { status: app_consts.IDLE };
  },
  loading_tenant_back_date_order: (state) => {
   state.tenant_back_date_order = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_back_date_order, fail_tenant_back_date_order, reset_tenant_back_date_order, loading_tenant_back_date_order } = tenant_back_date_order_Slice.actions;

export default tenant_back_date_order_Slice.reducer;